
import React from 'react';

interface ContentRowProps {
  title: string;
  description: string;
  imageUrl: string;
  reverse?: boolean;
}

const ContentRow: React.FC<ContentRowProps> = ({ 
  title, 
  description, 
  imageUrl, 
  reverse = false 
}) => {
  return (
    <div className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 mb-24 last:mb-0`}>
      <div className="w-full lg:w-1/2 relative group">
        {/* Accent border following the direction of the row */}
        <div className={`absolute ${reverse ? '-right-2' : '-left-2'} top-0 bottom-0 w-2 bg-indigo-600 rounded-full`}></div>
        <div className="overflow-hidden rounded-2xl shadow-2xl bg-slate-900">
          <img 
            src={imageUrl} 
            alt={title} 
            className="w-full h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
            onError={(e) => {
              // Fallback image if the primary one fails
              const target = e.target as HTMLImageElement;
              target.src = "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=1200";
            }}
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2 text-left">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white leading-tight">
          {title}
        </h2>
        <p className="text-slate-400 text-lg md:text-xl leading-relaxed mb-0 max-w-2xl">
          {description}
        </p>
      </div>
    </div>
  );
};

export const ContentSections: React.FC = () => {
  return (
    <section className="pt-24 pb-24 px-4 bg-slate-950">
      <div className="max-w-7xl mx-auto">
        <ContentRow 
          title="Inclusão na educação"
          description="Facilitamos o acesso de pessoas com dificuldade no aprendizado tradicional ou com acesso limitado ao ensino. Nossa plataforma adapta-se ao seu ritmo, removendo barreiras e criando um ambiente acolhedor onde cada progresso é celebrado, garantindo que ninguém fique para trás na jornada do conhecimento."
          imageUrl="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1200"
        />
        
        <ContentRow 
          reverse={true}
          title="A importância da IA"
          description="O uso de IA no ensino baseado em competências é crucial. Ela possibilita uma compreensão mais rápida dos atributos que compõem uma competência e permite o desenvolvimento ágil de trilhas personalizadas. A IA guia você no caminho exato para desenvolver as competências necessárias para solucionar seus problemas reais."
          imageUrl="https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&q=80&w=1200"
        />
      </div>
    </section>
  );
};
